export const PRIMARY = 'w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-4 rounded-lg transition-colors';
export const SECONDARY = 'w-full bg-gray-100 hover:bg-gray-200 text-gray-800 font-semibold py-3 px-4 rounded-lg transition-colors';
export const plural = (count: number, word: string) => `${count} ${word}${count === 1 ? '' : 's'}`;
